import script from "./PartnersView.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersView.vue?vue&type=script&setup=true&lang=js"

import "./PartnersView.vue?vue&type=style&index=0&id=e1af6de4&scoped=true&lang=css"

import exportComponent from "/home/appiah/Documents/projects/greenfield/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1af6de4"]])

export default __exports__